import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import ParticipantFieldConfigFormProps from './ParticipantFieldConfigFormProps';
import UI from '../../../../../common/UI';

interface Config {
  start_license: boolean;
  competition_license: boolean;
}

const KnwuLicenseConfigForm = (
  { config: initialConfig, onChange }: ParticipantFieldConfigFormProps,
) => {
  const { t } = useTranslation();

  const [config, setConfig] = useState<Config>((initialConfig as any) || {
    start_license: true,
    competition_license: true,
  });

  const toggleStartLicense = () => {
    setConfig((current) => ({
      ...current,
      start_license: !current.start_license,
    }));
  };

  const toggleCompetitionLicense = () => {
    setConfig((current) => ({
      ...current,
      competition_license: !current.competition_license,
    }));
  };

  useEffect(() => {
    onChange(config);
  }, [config]);

  return (
    <UI.InputGroup>
      <UI.InputLabel>
        {t('knwu_license_field.valid_licenses')}
      </UI.InputLabel>
      <UI.InputDescription>
        {t('knwu_license_field.valid_licenses_description')}
      </UI.InputDescription>
      <UI.Checkbox
        onChange={() => toggleStartLicense()}
        checked={config.start_license}
      >
        {t('knwu_license_field.start_license')}
      </UI.Checkbox>
      <UI.Checkbox
        onChange={() => toggleCompetitionLicense()}
        checked={config.competition_license}
      >
        {t('knwu_license_field.competition_license')}
      </UI.Checkbox>
    </UI.InputGroup>
  );
};

export default KnwuLicenseConfigForm;
